import React from 'react';

import { Container } from './styles';

function ButtonGroup({ children, ...rest }) {
  return (
    <Container size="sm" {...rest}>
      {children}
    </Container>
  );
}

export default ButtonGroup;
